import { useTranslation } from "react-i18next";
import { connectModal } from "redux-modal";
import BMXCardModal from "../../../../Components/Modals/BMXCardModal/BMXCardModal";
import EditServiceValuationPartForm from "../../Forms/ServiceForms/ServiceValuationForm/EditServiceValuationPartForm/EditServiceValuationPartForm";

const EditServiceValuationPartModal = (props) => {
    const { handleHide, show, header } = props;
    const { t } = useTranslation();

    return (
        <BMXCardModal
            width="350px"
            height="max-content"
            header={header || t("global:editservicevaluationpart")}
            open={show}
            onClose={handleHide}
            onOutside={false}
        >
            <EditServiceValuationPartForm {...props} />

        </BMXCardModal>
    );
};

export default connectModal({ name: "editServiceValuationPartModal" })(EditServiceValuationPartModal);